import React from 'react';

import * as Yup from 'yup';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { Button, Grid, TextField } from '@material-ui/core';

import { Form, ModalRoot, PasswordField } from 'components';
import { login, me } from 'store/modules/auth';
import { open } from 'store/modules/modal';

import smtLogo from 'static/vr-logo512.png';
import loginRightBg from 'static/bg2.jpg';

import styles from './Login.module.scss';

const validate = Yup.object().shape({
  email: Yup.string().required('Required').email('Invalid email address'),
  password: Yup.string().required('Required'),
});

const Login = props => {
  if (props.auth.user) {
    return <Redirect to="/dashboard" />;
  }

  const onSubmit = async (credentials, { setSubmitting }) => {
    const { login, me, showError, location, history } = props;

    try {
      const session = await login(credentials);
      const token =
        (session && session.token) ||
        (session && session.payload && session.payload.token);
      if (!token) {
        throw new Error('login failed');
      }
      const profile = await me();
      const email =
        (profile && profile.email) ||
        (profile && profile.payload && profile.payload.email);
      if (!email) {
        showError('Login worked but the session did not load. Retry.');
        return;
      }

      if (location.state && location.state.nextPathname) {
        history.push(location.state.nextPathname);
      } else {
        history.push('/dashboard');
      }
    } catch (err) {
      const status = err && err.response && err.response.status;
      if (!err || !err.response) {
        showError(
          'Cannot reach the API. It may be restarting — wait a few seconds and retry.'
        );
      } else if (status >= 500) {
        showError('API error. Wait a few seconds and retry.');
      } else {
        showError('Invalid email or password');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.login}>
      <div className={styles.form}>
        <div className={styles.header}>
          <img src={smtLogo} alt="Logo" className={styles.logo} />
        </div>

        <div className={styles.body}>
          <Form
            validationSchema={validate}
            initialValues={{ email: '', password: '' }}
            onSubmit={onSubmit}
          >
            {({ fieldProps, isSubmitting }) => (
              <div className={styles.frame}>
                <span className={styles.title}>Welcome to Skydome</span>

                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField {...fieldProps('email', 'Email')} />
                  </Grid>

                  <Grid item xs={12}>
                    <PasswordField {...fieldProps('password', 'Password')} />
                  </Grid>

                  <Grid item xs={12} className={styles.buttonWrapper}>
                    <Button
                      type="submit"
                      variant="contained"
                      className={styles.button}
                      disabled={isSubmitting}
                    >
                      Login
                    </Button>
                  </Grid>
                </Grid>
              </div>
            )}
          </Form>
        </div>
      </div>

      <div className={styles.banner} style={{ backgroundImage: `url(${loginRightBg})` }}>
        <div className={styles.container}>
          <span>Skydome</span>
          <span>You are a great sports fan.</span>
          <span>It’s time you were rewarded!</span>
          <span>Participate live with your favourite sports and teams</span>
          <span>
            during Lean In Moments<sup>TM</sup> of live games.
          </span>
          <div>
            <a href="https://www.skydomeapp.com/" target="blank">
              <div>LET'S PLAY</div>
            </a>
          </div>
        </div>
      </div>

      <ModalRoot />
    </div>
  );
};

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = dispatch => ({
  login: credentials => dispatch(login(credentials)),
  me: () => dispatch(me()),
  showError: message => dispatch(open({ modalType: 'error', modalProps: { message } })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
